import React from 'react'

class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, errorReference: null }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    const errorReference = `portal-${Date.now().toString(36)}`
    console.error('Portal render error:', {
      errorReference,
      message: error?.message,
      componentStack: errorInfo?.componentStack
    })
    this.setState({ errorReference })
  }

  handleRetry = () => {
    this.setState({ hasError: false, errorReference: null })
  }

  handleReload = () => {
    window.location.reload()
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="container-fluid min-vh-100 d-flex align-items-center justify-content-center bg-light p-4">
          <div className="card border-0 shadow-sm text-center" style={{ maxWidth: '460px' }}>
            <div className="card-body p-4">
              <i className="fas fa-exclamation-triangle text-warning fa-3x mb-3"></i>
              <h1 className="h4">The portal could not finish loading</h1>
              <p className="text-muted mb-4">
                Your session is still active. Try again first; if the issue continues, reload the portal.
              </p>
              {this.state.errorReference && (
                <p className="small text-muted">Support reference: {this.state.errorReference}</p>
              )}
              <div className="d-flex flex-column flex-sm-row justify-content-center gap-2">
                <button type="button" className="btn btn-outline-primary" onClick={this.handleRetry}>
                  <i className="fas fa-redo me-2"></i>
                  Try Again
                </button>
                <button type="button" className="btn btn-primary" onClick={this.handleReload}>
                  <i className="fas fa-sync-alt me-2"></i>
                  Reload Portal
                </button>
              </div>
            </div>
          </div>
        </div>
      )
    }

    return this.props.children
  }
}

export default AppErrorBoundary